<ng-container [formGroup]="formGroup">
  <mat-form-field class="settings-form__email-input">
    <mat-label>{{ "NOTIFICATION_SERVICE.EDIT.EMAIL_ADDRESS" | translate }}</mat-label>
    <input matInput formControlName="email" />
    <mat-icon matSuffix fontIcon="ec_edit"></mat-icon>
  </mat-form-field>
  <mat-divider big></mat-divider>
  <div class="settings-form__email-checkboxes">
    <div class="settings-form__checkbox-wrapper">
      <mat-checkbox formControlName="startEnd" [disableRipple]="true" [(indeterminate)]="indeterminate.startEnd">{{
        "NOTIFICATION_SERVICE.EDIT.TYP.MUNICIPAL_MEASURE_UPDATE" | translate
      }}</mat-checkbox>
      <app-badge [badge]="municipalBadge"></app-badge>
    </div>
    <div class="settings-form__checkbox-wrapper">
      <mat-checkbox
        formControlName="intermediate"
        [(indeterminate)]="indeterminate.intermediate"
        [disableRipple]="true"
        >{{ "NOTIFICATION_SERVICE.EDIT.TYP.NETWORK_PROVIDER_MEASURE_UPDATE" | translate }}</mat-checkbox
      >
      <app-badge [badge]="netzebwBadge"></app-badge>
    </div>
    <div class="settings-form__checkbox-wrapper">
      <mat-checkbox formControlName="dataStorage" [(indeterminate)]="indeterminate.dataStorage" [disableRipple]="true">
        {{ "NOTIFICATION_SERVICE.EDIT.TYP.DATA_STORAGE_DOCUMENT" | translate }}
      </mat-checkbox>
      <app-badge [badge]="documentsBadge"></app-badge>
    </div>
  </div>
</ng-container>
